/** Kleine Text-Formatierungshelfer fuer generierte Zusammenfassungen (Score-Begruendung,
 * Depot-Gesundheits-Zusammenfassung) - bewusst hier zentral statt in einem einzelnen
 * Feature-Modul, da an mehreren Stellen identisch gebraucht. */

export function joinWithUnd(items: string[]): string {
  if (items.length === 0) return "";
  if (items.length === 1) return items[0];
  return `${items.slice(0, -1).join(", ")} und ${items[items.length - 1]}`;
}

/** Nennt hoechstens `max` Eintraege namentlich, Rest wird gezaehlt statt aufgezaehlt -
 * bei vielen moeglichen Treffern sonst schnell eine unleserliche Aufzaehlung. */
export function summarizeLabels(labels: string[], max = 3): string {
  if (labels.length <= max) return joinWithUnd(labels);
  const remainder = labels.length - max;
  return `${joinWithUnd(labels.slice(0, max))} (+${remainder} weitere)`;
}
